export default {"src":"/_next/static/media/twitter.77ce8f6d.svg","height":28,"width":29,"blurWidth":0,"blurHeight":0};